import '../App.css';
import Home from './Home';
import Pagina from './Pagina';
import { BrowserRouter, Routes, Route } from "react-router";

function MainComponent() {
    return (
        <BrowserRouter>
            <Routes>
            <Route path="/" element={<Home />} />     
            <Route path="/funny/:pagina" element={<Pagina />} />      
            </Routes>
        </BrowserRouter>
    )
}

export default MainComponent;
